(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barbara-fiore-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bec-fiore-preview')) {
  customElements.define('bec-fiore-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const drawing = this.querySelector('.bec-fiore__drawing');
      const toggle = this.querySelector('.bec-fiore__toggle');
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        drawing.toggleAttribute('hidden', expanded);
        toggle.setAttribute('aria-expanded', String(!expanded));
        toggle.textContent = expanded ? toggle.dataset.show : toggle.dataset.hide;
      });
      document.fonts.ready.then(() => {
        if (!this.isConnected) return;
        const context = document.createElement('canvas').getContext('2d');
        const headlines = this.querySelectorAll('.bec-fiore__headline');
        const headlineStyle = getComputedStyle(headlines[1]);
        context.font = '500 100px ' + headlineStyle.fontFamily;
        const size = 100 * 715 / context.measureText(headlines[1].textContent).width;
        headlines.forEach(el => el.style.fontSize = size + 'px');
        const subtitle = this.querySelector('.bec-fiore__subtitle');
        context.font = '400 38px ' + getComputedStyle(subtitle).fontFamily;
        subtitle.style.fontSize = 38 * 535 / context.measureText(subtitle.textContent).width + 'px';
        this.querySelectorAll('.bec-fiore__copy text').forEach(el => {
          const style = getComputedStyle(el);
          context.font = style.fontWeight + ' ' + style.fontSize + ' ' + style.fontFamily;
          const first = context.measureText(el.textContent.charAt(0));
          const all = context.measureText(el.textContent);
          const shift = el.classList.contains('bec-fiore__headline') ? 0 : 4.6;
          el.setAttribute('x', String(176 + first.actualBoundingBoxLeft + shift));
          el.setAttribute('y', String(Number(el.dataset.inkTop) + all.actualBoundingBoxAscent));
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brigitte-hover-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('barbara-pattern-filter')) {
  customElements.define('barbara-pattern-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const controls = this.querySelector('[data-filter-controls]');
      if (!controls) return;
      const grid = this.querySelector('.brigitte-overview-preview__grid');
      const cards = [...grid.querySelectorAll(':scope > [data-pattern-category]')];
      const buttons = [...controls.querySelectorAll('button[data-filter]')];
      const status = this.querySelector('[data-filter-status]');
      const summary = controls.querySelector('summary');
      const selection = controls.querySelector('[data-filter-selection]');
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-filter]');
        if (!button || !controls.contains(button)) return;
        const category = button.dataset.filter;
        for (const item of buttons) item.setAttribute('aria-pressed', String(item === button));
        let visible = 0;
        for (const card of cards) {
          card.hidden = category !== 'all' && card.dataset.patternCategory !== category;
          if (!card.hidden) visible++;
        }
        grid.dataset.filtered = String(category !== 'all');
        selection.textContent = button.dataset.shortLabel || button.textContent.trim();
        status.textContent = button.textContent.trim() + ': ' + status.dataset.results.replace('__COUNT__', String(visible));
        controls.open = false;
        summary.focus();
      });
      this.onOutsideClick = (event) => { if (!controls.contains(event.target)) controls.open = false; };
      document.addEventListener('click', this.onOutsideClick);
      controls.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && controls.open) {
          event.preventDefault();
          controls.open = false;
          summary.focus();
        }
      });
      this.initialized = true;
      controls.hidden = false;
    }
    disconnectedCallback() {
      if (this.onOutsideClick) document.removeEventListener('click', this.onOutsideClick);
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fiore-product-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fiore-preview-gallery')) {
    customElements.define('fiore-preview-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.index = 0;
        this.updatePin();
        this.querySelector('.fiore-product-preview__controls').hidden = false;
        const copy = this.closest('.fiore-product-preview').querySelector('.fiore-product-preview__copy');
        const facts = copy.querySelector('.fiore-product-preview__facts');
        const overview = copy.querySelector('.be-product-overview');
        if (facts && overview && !facts.dataset.beProductFacts) {
          const labels = facts.textContent.split('·').map(label => label.trim());
          facts.dataset.beProductFacts = 'true';
          facts.replaceChildren(...labels.map(label => {
            const span = document.createElement('span');
            span.textContent = label;
            return span;
          }));
          overview.before(facts);
        }
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-fiore-step]');
          if (button) this.show(this.index + Number(button.dataset.fioreStep));
        });
        this.addEventListener('keydown', event => {
          if ((event.key === 'ArrowRight' || event.key === 'ArrowLeft') && !event.target.closest('video')) {
            event.preventDefault();
            this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
      }
      updatePin() {
        const link = this.querySelector('[data-be-pinterest]');
        const image = this.querySelector('[data-fiore-slide]:not([hidden]) img');
        if (!link) return;
        link.parentElement.style.visibility = image ? '' : 'hidden';
        if (!image) return;
        const source = new URL(image.currentSrc || image.src, location.origin);
        source.searchParams.set('width', '1920');
        const target = new URL('https://www.pinterest.com/pin/create/button/');
        target.searchParams.set('url', link.dataset.productUrl);
        target.searchParams.set('media', source.href);
        target.searchParams.set('description', link.dataset.description);
        link.href = target.href;
      }
      show(index) {
        const slides = [...this.querySelectorAll('[data-fiore-slide]')];
        this.index = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
          if (slide.hidden) slide.querySelector('video')?.pause();
        });
        this.querySelector('[data-fiore-counter]').textContent = `${this.index + 1} / ${slides.length}`;
        this.updatePin();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
